import axios from "axios";
import { isEuRegion } from "@/helpers/regions";
import $http from "@/helpers/http";
import { getAuthToken } from "@/helpers/auth";

/**
 * Determines the correct Flockmail API base URL based on the current environment and user region (EU or non-EU).
 * Returns the EU-specific URL if the user is in the EU region; otherwise, returns the default Flockmail API URL.
 */
export function getFlockmailBaseURL() {
  if (isEuRegion) {
    return process.env.VUE_APP_FLOCKMAIL_API_URL_EU;
  }
  return process.env.VUE_APP_FLOCKMAIL_API_URL;
}

/**
 * Creates an axios instance that behaves exactly like $http but with a different base URL
 * Optionally injects custom headers into every request.
 * @param {string} baseURL - The base URL to use for this instance
 * @param {function} [getHeaders] - Optional function returning an object of headers to merge into each request
 * @returns {Object} An axios instance with the same config and interceptors as $http
 */
export function createHttpWithBaseURL(baseURL, getHeaders) {
  const instance = axios.create({ baseURL });
  $http.interceptors.request.handlers.forEach(handler => {
    instance.interceptors.request.use(handler.fulfilled, handler.rejected);
  });
  $http.interceptors.response.handlers.forEach(handler => {
    instance.interceptors.response.use(handler.fulfilled, handler.rejected);
  });
  if (typeof getHeaders === "function") {
    instance.interceptors.request.use(config => {
      config.headers = {
        ...config.headers,
        ...getHeaders(),
      };
      return config;
    });
  }
  return instance;
}

// Create a nyx-specific http client that works just like $http, always adding x-a1 header
export const nyxHttp = createHttpWithBaseURL(getFlockmailBaseURL(), () => {
  const authToken = getAuthToken();
  return { "x-a1": `2;${authToken}` };
});
